exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-75552aea] .el-card__header {\n  background: #f5f7fa;\n}\n.info[data-v-75552aea] {\n  color: #333;\n}\n.table-wrap[data-v-75552aea] {\n  min-height: 500px;\n}\n", ""]);

// exports
